import { jsx } from 'react/jsx-runtime';
import SentryErrorBoundary from '../components/SentryErrorBoundary/SentryErrorBoundary.js';
import ConfigProvider from './ConfigProvider.js';
import ErrorContextProvider from './ErrorContextProvider.js';
import { I18nProvider } from './I18nProvider.js';
import Providers from './Providers.js';

/**
 * Pack in one place all the providers that are generally needed in our app.
 */
const CoreProviders = ({ errorContainerId, shopBundle, domain, locale, csrfToken, env, featureName, children, }) => {
    return (jsx(ConfigProvider, { env: env, shopBundle: shopBundle, children: jsx(I18nProvider, { env: env, shopBundle: shopBundle, locale: locale, children: jsx(SentryErrorBoundary, { featureName: featureName, children: jsx(ErrorContextProvider, { errorContainerId: errorContainerId, children: jsx(Providers, { shopBundle: shopBundle, domain: domain, locale: locale, csrfToken: csrfToken, children: children }) }) }) }) }));
};

export { CoreProviders as default };
//# sourceMappingURL=CoreProviders.js.map
